var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.right",modifiers:{"right":true}}],staticClass:"file-changed-icon gl-inline-block",class:{ 'ml-auto': _vm.isCentered },attrs:{"title":_vm.tooltipTitle}},[(_vm.showIcon)?_c('gl-icon',{class:_vm.changedIconClass,attrs:{"name":_vm.changedIcon,"size":_vm.size}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }